import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withTheme } from 'styled-components';

import { CollapsibleSectionView, primitives } from './CollapsibleSectionView';

export class BaseCollapsibleSection extends PureComponent {
    static propTypes = {
        defaultOpen: PropTypes.bool,
        headerText: PropTypes.string,
        headerOpenText: PropTypes.string,
    };

    static defaultProps = {
        defaultOpen: false,
        headerText: '',
        headerOpenText: '',
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.defaultOpen,
        };
    }

    render() {
        return (
            <CollapsibleSectionView
                isOpen={this.state.isOpen}
                onCollapseClick={this.handleClick}
                {...this.props}
            >
                {this.props.children}
            </CollapsibleSectionView>
        );
    }

    handleClick = () => this.setState({ isOpen: !this.state.isOpen });
}

export default withTheme(BaseCollapsibleSection);
export { primitives };
